import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import styled from 'styled-components';

import { DaysCarouselItem, DaysCarouselItemProps } from '../stories/DaysCarouselItem';

interface DaysCarouselProps {
  className?: string;
  onClickDayItem: (date: string) => void;
}

interface DaysCarouselItemPropsWithDate extends DaysCarouselItemProps {
  date: string;
}

export const DaysCarousel: React.FC<DaysCarouselProps> = ({
  className,
  onClickDayItem: handleDayItemClicked,
}) => {
  const __ = useTranslation().t;

  const userToday = localStorage.getItem('today') || moment.utc().format('YYYY-MM-DD');

  const [dayItems, setDayItems] = useState<DaysCarouselItemProps[]>([]);
  const settings = {
    variableWidth: true,
    infinite: false,
    arrows: false,
    slidesToScroll: 2,
  };

  useEffect(() => {
    setDayItems(buildDayItems());
  }, []);

  const onClickDayItem = (items: DaysCarouselItemPropsWithDate[], i: number) => {
    setDayItems(
      items.map((dayItem, key) => {
        return { ...dayItem, active: key === i };
      }),
    );
    handleDayItemClicked(items[i].date);
  };

  const buildDayItems = () => {
    const items: DaysCarouselItemPropsWithDate[] = [];
    for (let i = 0; i < 7; i++) {
      const day = moment.utc(userToday).startOf('day').add(i, 'days');
      const dayName = i === 0 ? __('today') : day.format('ddd').substring(0, 3);
      items.push({
        key: i,
        date: day.format('YYYY-MM-DD'),
        dayName,
        dayNumber: day.format('D'),
        active: i === 0,
        onClick: () => onClickDayItem(items, i),
      });
    }
    return items;
  };

  return (
    <Slider {...settings} className={className}>
      {dayItems.map((dayItem) => (
        <StyledDaysCarouselItem {...dayItem} />
      ))}
    </Slider>
  );
};

const StyledDaysCarouselItem = styled(DaysCarouselItem)`
  margin-right: 12px;
`;
